import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.includes";
/**
 * Layout: Styleguide
 * -----------------------------------------------------------------------------
 * Core entry file to register and display elements on the styleguide layout
 * - This entire styleguide layout is built by Vue.js
 */

import Vue from 'vue';
import { load } from '@shopify/theme-sections';
import '@/styles/styleguide.scss';
/**
 * Styleguide helpers.
 */

import EventBus from '~/helpers/event-bus';
/**
 * Styleguide components imports.
 */

import Accordion from '~/components/accordion';
import QuantitySelector from '~/components/quantity-selector';
import * as filters from '~/layout/styleguide/utils/filters';
/**
 * Vue Components
 */

import ContentBlock from '~/layout/styleguide/components/ContentBlock';
import ContentExample from '~/layout/styleguide/components/ContentExample';
import ContentSection from '~/layout/styleguide/components/ContentSection';
import IconGrid from '~/layout/styleguide/components/IconGrid';
import SideNav from '~/layout/styleguide/components/SideNav';
import SpecGrid from '~/layout/styleguide/components/SpecGrid';
import SpecGridRow from '~/layout/styleguide/components/SpecGridRow';
/**
* Frame utils.
*/

window.Frame = window.Frame || {};
window.Frame.EventBus = EventBus();
/**
 * Register global utility filters.
 */

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
new Vue({
  el: '#app',
  components: {
    ContentBlock,
    ContentExample,
    ContentSection,
    IconGrid,
    SideNav,
    SpecGrid,
    SpecGridRow
  },

  created() {
    if (!window.location.href.includes('#')) {
      window.location.href = "".concat(window.location.href, "#overview");
    }

    window.addEventListener('keyup', event => {
      if (event.keyCode === 27) {
        this.$root.$emit('navigation:toggle');
      }
    });
    this.$root.$on('updateView', () => {
      window.dispatchEvent(new window.CustomEvent('resize'));
    });
  },

  mounted() {
    /**
     * Initialise sections.
     */
    window.setTimeout(() => load('*'), 500);
    /**
     * Initialise components.
     */

    Accordion('.accordion').init();
    QuantitySelector('QuantitySelector-8').init();
  }

});